<template>
  <div
    class="category-item-container"
    :class="{ 'category-item-container--horizontal': horizontal }"
    @click.stop="$emit('click')"
  >
    <div
      class="category-icon-container"
      :class="{ 'touchable-scale': !disabled }"
    >
      <img class="category-image" :src="image" :alt="name" />
    </div>

    <p
      class="category-name-text"
      :style="{ paddingLeft: horizontal ? '0.625em' : '0' }"
    >
      {{ name }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "white"
    },
    name: {
      type: String,
      default: "Name"
    },
    image: {
      type: String,
      required: true
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.category-item-container {
  text-align: center;
}

.category-item-container--horizontal {
  display: inline-flex;
  align-items: center;
}

.category-icon-container {
  width: 2.25em;
  height: 2.25em;
  border-radius: 1.125em;
  display: flex;
  margin: auto;
  box-shadow: 0 0.0625em 0.1875em 0.0625em rgba(0, 0, 0, 0.2);
}

.category-name-text {
  color: var(--text-color);
  margin: 0;
}

.category-image {
  width: auto;
  height: 1.375em;
  margin: auto;
}
</style>
